import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: /*@__PURE__*/_normalizeClass(`as-goals-scored`)
}
const _hoisted_2 = { class: "as-goals-scored__head" }
const _hoisted_3 = { class: "as-history" }
const _hoisted_4 = { class: "as-history-item" }
const _hoisted_5 = { class: "as-history-item__head" }
const _hoisted_6 = { class: "as-history-item__body" }
const _hoisted_7 = {
  key: 0,
  class: "as-competition"
}
const _hoisted_8 = { class: "as-competition__table" }
const _hoisted_9 = { class: "as-center a" }
const _hoisted_10 = { class: "as-center a" }
const _hoisted_11 = {
  key: 1,
  class: "as-competition"
}
const _hoisted_12 = { class: "as-competition__table" }
const _hoisted_13 = { class: "as-center a" }
const _hoisted_14 = { class: "as-center a" }
const _hoisted_15 = { class: "as-center as-L" }
const _hoisted_16 = { class: "as-competition__table" }
const _hoisted_17 = { class: "as-center a" }
const _hoisted_18 = { class: "as-center a" }
const _hoisted_19 = { class: "as-center as-W" }

import IconGoalScored from "~src/components/icons/foot_stats/IconGoalScored.vue";
import type { IMatch } from "~src/interfaces";
import { ref, computed } from "vue";
import type {
  IFootyStats,
  ITeam,
  IStatsParent,
} from "~src/interfaces/footystats";
import { getClassForItem } from "~src/helpers/footystats";


const __default__ = {};

interface Props {
  match: IMatch;
  mode?: string;
  footyStats: IFootyStats | null;
  homeTeamInfo: ITeam | null;
  awayTeamInfo: ITeam | null;
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'BothTeamsScore',
  props: {
    match: {},
    mode: { default: "as-win" },
    footyStats: {},
    homeTeamInfo: {},
    awayTeamInfo: {}
  },
  setup(__props: any) {

const props = __props;

const activeTab = ref("all");
const setActiveTab = (tab: string) => {
  activeTab.value = tab;
};

const homeTeamLastX = computed<IStatsParent>(() => {
  return props.footyStats?.home_team_last_x ?? ({} as IStatsParent);
});

const awayTeamLastX = computed<IStatsParent>(() => {
  return props.footyStats?.away_team_last_x ?? ({} as IStatsParent);
});

const calculatorAVG = (home: number, away: number) => {
  const _avg = (home + away) / 2;

  return Math.round(_avg);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(IconGoalScored),
      _cache[2] || (_cache[2] = _createElementVNode("span", null, " Cả hai đội đều ghi bàn ", -1))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            class: _normalizeClass(["as-head-tab", { 'as-active': activeTab.value === 'all' }]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (setActiveTab('all')))
          }, " Cả trận ", 2),
          _createElementVNode("div", {
            class: _normalizeClass(["as-head-tab", { 'as-active': activeTab.value === 'half' }]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (setActiveTab('half')))
          }, " Hiệp 1/2 ", 2)
        ]),
        _createElementVNode("div", _hoisted_6, [
          (activeTab.value === 'all')
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("table", _hoisted_8, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _cache[3] || (_cache[3] = _createElementVNode("th", null, "BTTS", -1)),
                      _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.footyStats?.home_name), 1),
                      _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.footyStats?.away_name), 1),
                      _cache[4] || (_cache[4] = _createElementVNode("th", { class: "as-center a" }, "AVG", -1))
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", null, [
                      _cache[5] || (_cache[5] = _createElementVNode("td", null, "BTTS", -1)),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      homeTeamLastX.value.stats.seasonBTTSPercentage_overall
                    )}`)
                      }, _toDisplayString(homeTeamLastX.value.stats.seasonBTTSPercentage_overall) + "% ", 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      awayTeamLastX.value.stats.seasonBTTSPercentage_overall
                    )}`)
                      }, _toDisplayString(awayTeamLastX.value.stats.seasonBTTSPercentage_overall) + "% ", 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      calculatorAVG(
                        homeTeamLastX.value.stats.seasonBTTSPercentage_overall,
                        awayTeamLastX.value.stats.seasonBTTSPercentage_overall
                      )
                    )}`)
                      }, _toDisplayString(calculatorAVG(
                        homeTeamLastX.value.stats.seasonBTTSPercentage_overall,
                        awayTeamLastX.value.stats.seasonBTTSPercentage_overall
                      )) + "% ", 3)
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[6] || (_cache[6] = _createElementVNode("td", null, "BTTS & Thắng", -1)),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      homeTeamLastX.value.stats.BTTS_and_win_percentage_overall
                    )}`)
                      }, _toDisplayString(homeTeamLastX.value.stats.BTTS_and_win_percentage_overall) + "% ", 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      awayTeamLastX.value.stats.BTTS_and_win_percentage_overall
                    )}`)
                      }, _toDisplayString(awayTeamLastX.value.stats.BTTS_and_win_percentage_overall) + "% ", 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      calculatorAVG(
                        homeTeamLastX.value.stats.BTTS_and_win_percentage_overall,
                        awayTeamLastX.value.stats.BTTS_and_win_percentage_overall
                      )
                    )}`)
                      }, _toDisplayString(calculatorAVG(
                        homeTeamLastX.value.stats.BTTS_and_win_percentage_overall,
                        awayTeamLastX.value.stats.BTTS_and_win_percentage_overall
                      )) + "% ", 3)
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[7] || (_cache[7] = _createElementVNode("td", null, "BTTS & Hòa", -1)),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      homeTeamLastX.value.stats.BTTS_and_draw_percentage_overall
                    )}`)
                      }, _toDisplayString(homeTeamLastX.value.stats.BTTS_and_draw_percentage_overall) + "% ", 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      awayTeamLastX.value.stats.BTTS_and_draw_percentage_overall
                    )}`)
                      }, _toDisplayString(awayTeamLastX.value.stats.BTTS_and_draw_percentage_overall) + "% ", 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      calculatorAVG(
                        homeTeamLastX.value.stats.BTTS_and_draw_percentage_overall,
                        awayTeamLastX.value.stats.BTTS_and_draw_percentage_overall
                      )
                    )}`)
                      }, _toDisplayString(calculatorAVG(
                        homeTeamLastX.value.stats.BTTS_and_draw_percentage_overall,
                        awayTeamLastX.value.stats.BTTS_and_draw_percentage_overall
                      )) + "% ", 3)
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[8] || (_cache[8] = _createElementVNode("td", null, "BTTS & Thua", -1)),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      homeTeamLastX.value.stats.BTTS_and_lose_percentage_overall
                    )}`)
                      }, _toDisplayString(homeTeamLastX.value.stats.BTTS_and_lose_percentage_overall) + "% ", 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      awayTeamLastX.value.stats.BTTS_and_lose_percentage_overall
                    )}`)
                      }, _toDisplayString(awayTeamLastX.value.stats.BTTS_and_lose_percentage_overall) + "% ", 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      calculatorAVG(
                        homeTeamLastX.value.stats.BTTS_and_lose_percentage_overall,
                        awayTeamLastX.value.stats.BTTS_and_lose_percentage_overall
                      )
                    )}`)
                      }, _toDisplayString(calculatorAVG(
                        homeTeamLastX.value.stats.BTTS_and_lose_percentage_overall,
                        awayTeamLastX.value.stats.BTTS_and_lose_percentage_overall
                      )) + "% ", 3)
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[9] || (_cache[9] = _createElementVNode("td", null, "BTTS & Trên 2.5", -1)),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      homeTeamLastX.value.stats.additional_info
                        .over25_and_btts_percentage_overall
                    )}`)
                      }, _toDisplayString(homeTeamLastX.value.stats.additional_info
                        .over25_and_btts_percentage_overall) + "% ", 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      awayTeamLastX.value.stats.additional_info
                        .over25_and_btts_percentage_overall
                    )}`)
                      }, _toDisplayString(awayTeamLastX.value.stats.additional_info
                        .over25_and_btts_percentage_overall) + "% ", 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      calculatorAVG(
                        homeTeamLastX.value.stats.additional_info
                          .over25_and_btts_percentage_overall,
                        awayTeamLastX.value.stats.additional_info
                          .over25_and_btts_percentage_overall
                      )
                    )}`)
                      }, _toDisplayString(calculatorAVG(
                        homeTeamLastX.value.stats.additional_info
                          .over25_and_btts_percentage_overall,
                        awayTeamLastX.value.stats.additional_info
                          .over25_and_btts_percentage_overall
                      )) + "% ", 3)
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[10] || (_cache[10] = _createElementVNode("td", null, "BTTS No & Trên 2.5", -1)),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      homeTeamLastX.value.stats.additional_info
                        .over25_and_no_btts_percentage_overall
                    )}`)
                      }, _toDisplayString(homeTeamLastX.value.stats.additional_info
                        .over25_and_no_btts_percentage_overall) + "% ", 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      awayTeamLastX.value.stats.additional_info
                        .over25_and_no_btts_percentage_overall
                    )}`)
                      }, _toDisplayString(awayTeamLastX.value.stats.additional_info
                        .over25_and_no_btts_percentage_overall) + "% ", 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      calculatorAVG(
                        homeTeamLastX.value.stats.additional_info
                          .over25_and_no_btts_percentage_overall,
                        awayTeamLastX.value.stats.additional_info
                          .over25_and_no_btts_percentage_overall
                      )
                    )}`)
                      }, _toDisplayString(calculatorAVG(
                        homeTeamLastX.value.stats.additional_info
                          .over25_and_no_btts_percentage_overall,
                        awayTeamLastX.value.stats.additional_info
                          .over25_and_no_btts_percentage_overall
                      )) + "% ", 3)
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (activeTab.value === 'half')
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("table", _hoisted_12, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _cache[11] || (_cache[11] = _createElementVNode("th", null, "First Half Goals", -1)),
                      _createElementVNode("th", _hoisted_13, _toDisplayString(_ctx.footyStats?.home_name), 1),
                      _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.footyStats?.away_name), 1),
                      _cache[12] || (_cache[12] = _createElementVNode("th", { class: "as-center a" }, "AVG", -1))
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", null, [
                      _cache[13] || (_cache[13] = _createElementVNode("td", null, "BTTS First Half", -1)),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      homeTeamLastX.value.stats.btts_fhg_percentage_overall
                    )}`)
                      }, _toDisplayString(homeTeamLastX.value.stats.btts_fhg_percentage_overall) + "% ", 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      awayTeamLastX.value.stats.btts_fhg_percentage_overall
                    )}`)
                      }, _toDisplayString(awayTeamLastX.value.stats.btts_fhg_percentage_overall) + "% ", 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      calculatorAVG(
                        homeTeamLastX.value.stats.btts_fhg_percentage_overall,
                        awayTeamLastX.value.stats.btts_fhg_percentage_overall
                      )
                    )}`)
                      }, _toDisplayString(calculatorAVG(
                        homeTeamLastX.value.stats.btts_fhg_percentage_overall,
                        awayTeamLastX.value.stats.btts_fhg_percentage_overall
                      )) + "% ", 3)
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[14] || (_cache[14] = _createElementVNode("td", null, "Over 0.5 FH", -1)),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      homeTeamLastX.value.stats.seasonOver05PercentageHT_overall
                    )}`)
                      }, _toDisplayString(homeTeamLastX.value.stats.seasonOver05PercentageHT_overall) + "% ", 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      awayTeamLastX.value.stats.seasonOver05PercentageHT_overall
                    )}`)
                      }, _toDisplayString(awayTeamLastX.value.stats.seasonOver05PercentageHT_overall) + "% ", 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      calculatorAVG(
                        homeTeamLastX.value.stats.seasonOver05PercentageHT_overall,
                        awayTeamLastX.value.stats.seasonOver05PercentageHT_overall
                      )
                    )}`)
                      }, _toDisplayString(calculatorAVG(
                        homeTeamLastX.value.stats.seasonOver05PercentageHT_overall,
                        awayTeamLastX.value.stats.seasonOver05PercentageHT_overall
                      )) + "% ", 3)
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[15] || (_cache[15] = _createElementVNode("td", null, "Over 1.5 FH", -1)),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      homeTeamLastX.value.stats.seasonOver15PercentageHT_overall
                    )}`)
                      }, _toDisplayString(homeTeamLastX.value.stats.seasonOver15PercentageHT_overall) + "% ", 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      awayTeamLastX.value.stats.seasonOver15PercentageHT_overall
                    )}`)
                      }, _toDisplayString(awayTeamLastX.value.stats.seasonOver15PercentageHT_overall) + "% ", 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      calculatorAVG(
                        homeTeamLastX.value.stats.seasonOver15PercentageHT_overall,
                        awayTeamLastX.value.stats.seasonOver15PercentageHT_overall
                      )
                    )}`)
                      }, _toDisplayString(calculatorAVG(
                        homeTeamLastX.value.stats.seasonOver15PercentageHT_overall,
                        awayTeamLastX.value.stats.seasonOver15PercentageHT_overall
                      )) + "% ", 3)
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[16] || (_cache[16] = _createElementVNode("td", null, "Over 2.5 FH", -1)),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      homeTeamLastX.value.stats.seasonOver25PercentageHT_overall
                    )}`)
                      }, _toDisplayString(homeTeamLastX.value.stats.seasonOver25PercentageHT_overall) + "% ", 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      awayTeamLastX.value.stats.seasonOver25PercentageHT_overall
                    )}`)
                      }, _toDisplayString(awayTeamLastX.value.stats.seasonOver25PercentageHT_overall) + "% ", 3),
                      _createElementVNode("td", _hoisted_15, _toDisplayString(calculatorAVG(
                        homeTeamLastX.value.stats.seasonOver25PercentageHT_overall,
                        awayTeamLastX.value.stats.seasonOver25PercentageHT_overall
                      )) + "% ", 1)
                    ])
                  ])
                ]),
                _cache[24] || (_cache[24] = _createElementVNode("br", null, null, -1)),
                _createElementVNode("table", _hoisted_16, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _cache[17] || (_cache[17] = _createElementVNode("th", null, "2nd Half Goals", -1)),
                      _createElementVNode("th", _hoisted_17, _toDisplayString(_ctx.footyStats?.home_name), 1),
                      _createElementVNode("th", _hoisted_18, _toDisplayString(_ctx.footyStats?.away_name), 1),
                      _cache[18] || (_cache[18] = _createElementVNode("th", { class: "as-center a" }, "AVG", -1))
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", null, [
                      _cache[19] || (_cache[19] = _createElementVNode("td", null, "BTTS 2nd Half", -1)),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      homeTeamLastX.value.stats.btts_2hg_percentage_overall
                    )}`)
                      }, _toDisplayString(homeTeamLastX.value.stats.btts_2hg_percentage_overall) + "% ", 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      awayTeamLastX.value.stats.btts_2hg_percentage_overall
                    )}`)
                      }, _toDisplayString(awayTeamLastX.value.stats.btts_2hg_percentage_overall) + "% ", 3),
                      _createElementVNode("td", _hoisted_19, _toDisplayString(calculatorAVG(
                        homeTeamLastX.value.stats.btts_2hg_percentage_overall,
                        awayTeamLastX.value.stats.btts_2hg_percentage_overall
                      )) + "% ", 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[20] || (_cache[20] = _createElementVNode("td", null, "BTTS Both Halves", -1)),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      homeTeamLastX.value.stats.BTTS_both_halves_percentage_overall
                    )}`)
                      }, _toDisplayString(homeTeamLastX.value.stats.BTTS_both_halves_percentage_overall) + "% ", 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      awayTeamLastX.value.stats.BTTS_both_halves_percentage_overall
                    )}`)
                      }, _toDisplayString(awayTeamLastX.value.stats.BTTS_both_halves_percentage_overall) + "% ", 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      calculatorAVG(
                        homeTeamLastX.value.stats.BTTS_both_halves_percentage_overall,
                        awayTeamLastX.value.stats.BTTS_both_halves_percentage_overall
                      )
                    )}`)
                      }, _toDisplayString(calculatorAVG(
                        homeTeamLastX.value.stats.BTTS_both_halves_percentage_overall,
                        awayTeamLastX.value.stats.BTTS_both_halves_percentage_overall
                      )) + "% ", 3)
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[21] || (_cache[21] = _createElementVNode("td", null, "Over 0.5 2H", -1)),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      homeTeamLastX.value.stats.over05_2hg_percentage_overall
                    )}`)
                      }, _toDisplayString(homeTeamLastX.value.stats.over05_2hg_percentage_overall) + "% ", 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      awayTeamLastX.value.stats.over05_2hg_percentage_overall
                    )}`)
                      }, _toDisplayString(awayTeamLastX.value.stats.over05_2hg_percentage_overall) + "% ", 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      calculatorAVG(
                        homeTeamLastX.value.stats.over05_2hg_percentage_overall,
                        awayTeamLastX.value.stats.over05_2hg_percentage_overall
                      )
                    )}`)
                      }, _toDisplayString(calculatorAVG(
                        homeTeamLastX.value.stats.over05_2hg_percentage_overall,
                        awayTeamLastX.value.stats.over05_2hg_percentage_overall
                      )) + "% ", 3)
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[22] || (_cache[22] = _createElementVNode("td", null, "Over 1.5 2H", -1)),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      homeTeamLastX.value.stats.over15_2hg_percentage_overall
                    )}`)
                      }, _toDisplayString(homeTeamLastX.value.stats.over15_2hg_percentage_overall) + "% ", 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      awayTeamLastX.value.stats.over15_2hg_percentage_overall
                    )}`)
                      }, _toDisplayString(awayTeamLastX.value.stats.over15_2hg_percentage_overall) + "% ", 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      calculatorAVG(
                        homeTeamLastX.value.stats.over15_2hg_percentage_overall,
                        awayTeamLastX.value.stats.over15_2hg_percentage_overall
                      )
                    )}`)
                      }, _toDisplayString(calculatorAVG(
                        homeTeamLastX.value.stats.over15_2hg_percentage_overall,
                        awayTeamLastX.value.stats.over15_2hg_percentage_overall
                      )) + "% ", 3)
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[23] || (_cache[23] = _createElementVNode("td", null, "Over 2.5 2H", -1)),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      homeTeamLastX.value.stats.over25_2hg_percentage_overall
                    )}`)
                      }, _toDisplayString(homeTeamLastX.value.stats.over25_2hg_percentage_overall) + "% ", 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      awayTeamLastX.value.stats.over25_2hg_percentage_overall
                    )}`)
                      }, _toDisplayString(awayTeamLastX.value.stats.over25_2hg_percentage_overall) + "% ", 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(`as-center ${_unref(getClassForItem)(
                      calculatorAVG(
                        homeTeamLastX.value.stats.over25_2hg_percentage_overall,
                        awayTeamLastX.value.stats.over25_2hg_percentage_overall
                      )
                    )}`)
                      }, _toDisplayString(calculatorAVG(
                        homeTeamLastX.value.stats.over25_2hg_percentage_overall,
                        awayTeamLastX.value.stats.over25_2hg_percentage_overall
                      )) + "% ", 3)
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})